import HNSColors from "../../../../ui library/HNSColors";

export const transformDistanceString = (distanceStr) => {
  if (!distanceStr) {
    return 0;
  }

  const miles = parseFloat(distanceStr.replace(/[^\d.]/g, ""));
  if (isNaN(miles)) {
    return 0;
  }
  return miles;
};

export const milesToMeters = (miles) => {
  return miles * 1609.34;
};

export const getBackgroundColor = (row) => {
  const inNetwork = row?.inNetwork;
  const receivingClients = row?.receivingClients;
  if (inNetwork && receivingClients) {
    return HNSColors.success[400];
  }
  if (inNetwork && !receivingClients) {
    return HNSColors.warning[500];
  }
  if (!inNetwork && !receivingClients) {
    return HNSColors.failure[500];
  }
  return HNSColors.neutrals[500];
};

// Pre-generate SVG strings with colors
export const PREGENERATED_SVGS = {
  inNetworkReceivingClients: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
    <path
      d="M10.9995 0.91626C13.1875 0.91626 15.2863 1.78608 16.8335 3.33325C18.3805 4.88033 19.2494 6.97842 19.2495 9.16626C19.2495 12.2783 17.2065 15.2519 15.3521 17.3381C14.4033 18.4055 13.4572 19.2921 12.7495 19.9114C12.395 20.2215 12.0984 20.4659 11.8892 20.634L11.5503 20.8997C11.2651 21.1135 10.8862 21.1401 10.5776 20.9797L10.4497 20.8997L10.356 20.8284C10.2983 20.7837 10.2154 20.7181 10.1108 20.634C9.90159 20.4659 9.60491 20.2215 9.25049 19.9114C8.54279 19.2921 7.59669 18.4055 6.64795 17.3381C4.79348 15.2519 2.74951 12.2784 2.74951 9.16626C2.7496 6.97834 3.61941 4.88035 5.1665 3.33325C6.7136 1.78615 8.81159 0.916346 10.9995 0.91626Z"
      fill="${HNSColors.success[400]}"
      stroke="white"
      stroke-width="1.83333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11 11.9167C12.5188 11.9167 13.75 10.6855 13.75 9.16675C13.75 7.64796 12.5188 6.41675 11 6.41675C9.48122 6.41675 8.25 7.64796 8.25 9.16675C8.25 10.6855 9.48122 11.9167 11 11.9167Z"
      fill="white"
      stroke="white"
      stroke-width="1.375"
    />
  </svg>
  `)}`,
  inNetworkNotReceivingClients: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
    <path
      d="M10.9995 0.91626C13.1875 0.91626 15.2863 1.78608 16.8335 3.33325C18.3805 4.88033 19.2494 6.97842 19.2495 9.16626C19.2495 12.2783 17.2065 15.2519 15.3521 17.3381C14.4033 18.4055 13.4572 19.2921 12.7495 19.9114C12.395 20.2215 12.0984 20.4659 11.8892 20.634L11.5503 20.8997C11.2651 21.1135 10.8862 21.1401 10.5776 20.9797L10.4497 20.8997L10.356 20.8284C10.2983 20.7837 10.2154 20.7181 10.1108 20.634C9.90159 20.4659 9.60491 20.2215 9.25049 19.9114C8.54279 19.2921 7.59669 18.4055 6.64795 17.3381C4.79348 15.2519 2.74951 12.2784 2.74951 9.16626C2.7496 6.97834 3.61941 4.88035 5.1665 3.33325C6.7136 1.78615 8.81159 0.916346 10.9995 0.91626Z"
      fill="${HNSColors.warning[500]}"
      stroke="white"
      stroke-width="1.83333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11 11.9167C12.5188 11.9167 13.75 10.6855 13.75 9.16675C13.75 7.64796 12.5188 6.41675 11 6.41675C9.48122 6.41675 8.25 7.64796 8.25 9.16675C8.25 10.6855 9.48122 11.9167 11 11.9167Z"
      fill="white"
      stroke="white"
      stroke-width="1.375"
    />
  </svg>
  `)}`,
  outOfNetwork: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
    <path
      d="M10.9995 0.91626C13.1875 0.91626 15.2863 1.78608 16.8335 3.33325C18.3805 4.88033 19.2494 6.97842 19.2495 9.16626C19.2495 12.2783 17.2065 15.2519 15.3521 17.3381C14.4033 18.4055 13.4572 19.2921 12.7495 19.9114C12.395 20.2215 12.0984 20.4659 11.8892 20.634L11.5503 20.8997C11.2651 21.1135 10.8862 21.1401 10.5776 20.9797L10.4497 20.8997L10.356 20.8284C10.2983 20.7837 10.2154 20.7181 10.1108 20.634C9.90159 20.4659 9.60491 20.2215 9.25049 19.9114C8.54279 19.2921 7.59669 18.4055 6.64795 17.3381C4.79348 15.2519 2.74951 12.2784 2.74951 9.16626C2.7496 6.97834 3.61941 4.88035 5.1665 3.33325C6.7136 1.78615 8.81159 0.916346 10.9995 0.91626Z"
      fill="${HNSColors.failure[500]}"
      stroke="white"
      stroke-width="1.83333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11 11.9167C12.5188 11.9167 13.75 10.6855 13.75 9.16675C13.75 7.64796 12.5188 6.41675 11 6.41675C9.48122 6.41675 8.25 7.64796 8.25 9.16675C8.25 10.6855 9.48122 11.9167 11 11.9167Z"
      fill="white"
      stroke="white"
      stroke-width="1.375"
    />
  </svg>
  `)}`,
  origin: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
    <path
      d="M10.9995 0.91626C13.1875 0.91626 15.2863 1.78608 16.8335 3.33325C18.3805 4.88033 19.2494 6.97842 19.2495 9.16626C19.2495 12.2783 17.2065 15.2519 15.3521 17.3381C14.4033 18.4055 13.4572 19.2921 12.7495 19.9114C12.395 20.2215 12.0984 20.4659 11.8892 20.634L11.5503 20.8997C11.2651 21.1135 10.8862 21.1401 10.5776 20.9797L10.4497 20.8997L10.356 20.8284C10.2983 20.7837 10.2154 20.7181 10.1108 20.634C9.90159 20.4659 9.60491 20.2215 9.25049 19.9114C8.54279 19.2921 7.59669 18.4055 6.64795 17.3381C4.79348 15.2519 2.74951 12.2784 2.74951 9.16626C2.7496 6.97834 3.61941 4.88035 5.1665 3.33325C6.7136 1.78615 8.81159 0.916346 10.9995 0.91626Z"
      fill="${HNSColors.primary[600]}"
      stroke="white"
      stroke-width="1.83333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11 11.9167C12.5188 11.9167 13.75 10.6855 13.75 9.16675C13.75 7.64796 12.5188 6.41675 11 6.41675C9.48122 6.41675 8.25 7.64796 8.25 9.16675C8.25 10.6855 9.48122 11.9167 11 11.9167Z"
      fill="white"
      stroke="white"
      stroke-width="1.375"
    />
  </svg>
  `)}`,
};

// Map row attributes to the correct pre-generated icon
export const getIconURL = (row, origin = false) => {
  if (origin) {
    return PREGENERATED_SVGS.origin;
  }
  if (row?.inNetwork && row?.receivingClients) {
    return PREGENERATED_SVGS.inNetworkReceivingClients;
  }
  if (row?.inNetwork && !row?.receivingClients) {
    return PREGENERATED_SVGS.inNetworkNotReceivingClients;
  }
  if (!row?.inNetwork && !row?.receivingClients) {
    return PREGENERATED_SVGS.outOfNetwork;
  }

  return PREGENERATED_SVGS.outOfNetwork;
};

export const formatTime = (dateStr) => {
  if (!dateStr) {
    return null;
  }
  const date = dateStr instanceof Date ? dateStr : new Date(dateStr);
  const hh = String(date.getHours()).padStart(2, "0");
  const mm = String(date.getMinutes()).padStart(2, "0");
  const ss = String(date.getSeconds()).padStart(2, "0");

  return `${hh}:${mm}:${ss}`;
};
